<template>
  <div class="page-container content-430">
    <Form
      ref="searchForm"
      label-position="right"
      :label-width="0"
      class="search-list-430 search-wrapper-430"
    >
      <Row class="relative" type="flex" flex="end">
        <FormItem label="">
          <Input
            v-model.trim="searchConds.searchStr"
            placeholder="单位全称/简称/组织机构代码/联系人姓名/手机号"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="">
          <Select
            v-model="searchConds.orgKind"
            placeholder="单位类别"
            clearable
            filterable
          >
            <Option
              v-for="(item, index) in orgKindList"
              :key="index"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="">
          <Cascader
            v-model="searchConds.area"
            placeholder="所属行政区"
            clearable
            :data="regionDataList"
            @on-change="handelAreaChange"
          ></Cascader>
        </FormItem>
        <FormItem label="">
          <Select
            v-model="searchConds.coSts"
            placeholder="合作状态"
            clearable
            filterable
          >
            <Option
              v-for="(item, index) in cooperationList"
              :key="index"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="">
          <Select
            v-model="searchConds.infoSts"
            placeholder="信息完善状态"
            clearable
            filterable
          >
            <Option
              v-for="(item, index) in completeStatusList"
              :key="index"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem v-if="userInfo.userType === 5" label="">
          <Select
            v-model="searchConds.reviewState"
            placeholder="教育局审批状态"
            clearable
            filterable
          >
            <Option
              v-for="(item, index) in reviewStateList"
              :key="index"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>

        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="search-430" @click="handleReset">重置</Button>
      </Row>
    </Form>
    <div class="main-wrapper">
      <div class="table-title-special-430 flex justify-content_end">
        <div v-if="userInfo.userType == 5" class="top-operate">
          <Button
            type="primary"
            class="op-btn"
            @click="handleRemoveServe"
          >解除服务合作</Button>
          <EditButton
            redirect-url="operatingCenter/organization/org/Index"
          ></EditButton>
        </div>
      </div>
      <div class="table">
        <Table
          ref="selection"
          border
          :columns="tableColumns"
          :data="tableData"
          @on-selection-change="getListSelected"
        >
          <!-- v1.3.1 仅限超管账号有此功能，子账号没有-->
          <template
            v-if="userInfo.userType == 5"
            slot="reviewState"
            slot-scope="{ row }"
          >
            <div v-if="row.reviewState == 0">
              <span class="check-status-430">审批中</span>
              <span>|</span>
              <span
                style="margin-right: 5px; cursor: pointer; color: #1c7ffe"
                @click.prevent.stop="goApproval(row)"
              >审批</span>
            </div>
            <div v-if="row.reviewState == 2">
              <span class="stop-status-430">审批驳回</span>
              <!-- <span>|</span>
              <span style="margin-right: 5px;cursor: pointer;color:#00CC99" @click.prevent.stop="goApproval(row)">审批</span> -->
            </div>
            <div v-if="row.reviewState == 1" class="pass-status-430">
              已通过
            </div>
          </template>
          <template slot="action" slot-scope="{ row }">
            <span
              class="operate-btn-430"
              @click="handleToDetail(row)"
            >查看详情</span>
          </template>
        </Table>
      </div>
      <div class="paging">
        <Page
          :total="pageInfo.total"
          show-total
          show-elevator
          :current="pageInfo.pageNum"
          :page-size="pageInfo.pageSize"
          @on-change="handlePageChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="modalRemoveShow"
      title="解除服务合作"
      :loading="loading"
      @on-ok="handleOk('formValidate')"
      @on-cancel="handleCancel('formValidate')"
    >
      <div class="page_modal">
        <Form
          ref="formValidate"
          :rules="ruleValidate"
          :model="formValidate"
          :label-width="150"
        >
          <FormItem label="与学校状态：" prop="status">
            <Select v-model="formValidate.status" style="width: 200px">
              <Option value="0">解除合作</Option>
            </Select>
          </FormItem>
          <FormItem label="原因：" prop="cancelReason">
            <Input
              v-model="formValidate.cancelReason"
              style="width: 300px"
              placeholder="请输入原因"
            ></Input>
          </FormItem>
          <Input style="display: none"></Input>
          <FormItem label="当前帐号登录密码：" prop="password">
            <Input
              v-model="formValidate.password"
              style="width: 300px"
              type="password"
              placeholder="请输入当前帐号登录密码"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="text" @click="handleCancel('formValidate')">取消</Button>
        <Button type="primary" @click="handleOK('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { regionDataList } from '@/utils/dictionary';
import educationAdmin from '@/request/educationAdmin/index.js';
import operationAdmin from '@/request/operationAdmin/index.js';
import { opeEduListColumns } from '@/pages/assetsModules/manageData.js';
import { orgKindList, cooperationList, completeStatusList, changeDictionaries, reviewStateList } from '@/utils/dictionary.js';
import EditButton from '@/pages/assetsModules/EditButton';
export default {
  name: 'ResourceEducationMage',
  components: {
    EditButton
  },
  filters: {
    InitCooperateState(v) {
      switch (v) {
        case 1:
          return '正常';
        case 2:
          return '已停止合作';
      }
    }
  },
  data() {
    return {
      regionDataList: [],
      pageInfo: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      searchConds: {
        searchStr: null, //  搜索关键词 单位全称、简称、组织机构代码、联系人姓名、手机号等
        orgKind: null, // 单位类别 1：正式号 2：测试号 3：体验号
        area: [],
        areaCode: null, // 所属行政区
        infoSts: null, // 信息完善状态 0：待完善 1：信息完善
        coSts: null, // 单位合作状态 0：默认 1：合作 2：洽谈中 3：终止合作
        reviewState: null // 教育局审批状态 0：未审批 1：通过 2：不通过 当前用户是超管时这个筛选条件才会生效
      },
      tableColumns: [...opeEduListColumns],
      orgKindList, // 单位类别列表
      cooperationList, // 合作状态列表
      completeStatusList, // 信息完善状态
      reviewStateList, // 教育局审批状态
      tableData: [],
      formValidate: {
        status: '',
        cancelReason: '',
        password: ''
      },
      ruleValidate: {
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        cancelReason: [
          { required: true, message: '请输入原因', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入当前帐号登录密码', trigger: 'blur' }
        ]
      },
      selectOrgData: [], // 勾选的服务列表数据
      selectOrgIds: '', // 选择的服务数据的id拼接
      modalRemoveShow: false, // 弹窗显隐
      loading: false
    };
  },
  computed: { ...mapState(['userInfo']), ...mapGetters(['routeTitle']) },
  created() {
    this.regionDataList = [...regionDataList];
    this.getOrgList();
    this.tableColumns.unshift({
      type: 'selection',
      width: 60,
      align: 'center',
      fixed: 'left'
    });
    this.tableColumns.push({
      title: '教育局审批状态',
      slot: 'reviewState',
      minWidth: 180,
      align: 'center'

      // render: (h, params) => {
      //   return h('div', {
      //     class: {
      //       'check-status-430': params.row.reviewState === 0,
      //       'pass-status-430': params.row.reviewState === 1,
      //       'stop-status-430': params.row.reviewState === 2
      //     }
      //   }, [changeDictionaries(reviewStateList)[params.row.reviewState]]);
      // }
    });
  },
  methods: {
    // 地区选择
    handelAreaChange(value, selectedData) {
      this.searchConds.area = value;
      this.searchConds.areaCode = value[value.length - 1];
    },
    // 重置
    handleReset() {
      this.searchConds = {
        searchStr: null, //  搜索关键词 单位全称、简称、组织机构代码、联系人姓名、手机号等
        orgKind: null, // 单位类别 1：正式号 2：测试号 3：体验号
        areaCode: null, // 所属行政区
        infoSts: null, // 信息完善状态 0：待完善 1：信息完善
        coSts: null, // 单位合作状态 0：默认 1：合作 2：洽谈中 3：终止合作
        reviewState: null // 教育局审批状态 0：未审批 1：通过 2：不通过 当前用户是超管时这个筛选条件才会生效
      };
      this.pageInfo.pageNum = 1;
      this.getOrgList();
    },
    // 查询
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getOrgList();
    },
    // 分页
    handlePageChange(v) {
      this.pageInfo.pageNum = v;
      this.getOrgList();
    },
    // 服务机构详情
    handleToDetail(row, index) {
      this.$router.push({
        name: 'resources_organ_details',
        query: { orgId: row.orgId }
      });
    },
    // 查询服务机构列表
    async getOrgList() {
      const { total, ...pageInfo } = this.pageInfo;
      const { area, ...searchConds } = this.searchConds;
      const params = { ...pageInfo, ...searchConds, bureauId: this.userInfo.orgId };
      const res = await educationAdmin.getEduOrgListNew(params);

      if (res.status === 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      } else {
        this.$Message.error(res.message);
      }
    },
    getListSelected(selection) {
      this.selectOrgData = selection;
      this.selectOrgIds = '';
      selection.forEach((item, index) => {
        if (index === 0) {
          this.selectOrgIds = item.relId;// 由orgId更改为relId（关联关系id）
        } else {
          this.selectOrgIds += ',' + item.relId;
        }
      });
    },
    // 点击解除服务合作
    handleRemoveServe() {
      if (this.selectOrgData.length === 0) {
        return this.$Message.error('请勾选一条记录');
      }
      if (this.selectOrgData.length !== 1) {
        return this.$Message.error('只能勾选一条记录');
      }
      this.modalRemoveShow = true;
    },
    handleCancel(name) {
      this.modalRemoveShow = false;
      this.handleRuleReset(name);
    },
    handleRuleReset(name) {
      this.$refs[name].resetFields();
    },
    handleOK(name) {
      this.handleSubmit(name);
    },
    handleSubmit(name) {
      this.loading = false;
      setTimeout(() => {
        this.loading = true;
      }, 100);
      this.$refs[name].validate(valid => {
        if (valid) {
          this.delorgByForEdu();
        }
      });
    },
    goApproval(row) {
      this.$router.push({
        name: 'resources_organ_details',
        query: { orgId: row.orgId, type: 'check', id: row.relId }
      });
    },
    // 教育局服务解除关联
    async delorgByForEdu() {
      const params = {
        id: this.selectOrgIds,
        status: this.formValidate.status,
        cancelReason: this.formValidate.cancelReason,
        password: this.formValidate.password
      };
      const res = await operationAdmin.disassociateOrgAndEduNew(params);
      if (res.status === 200) {
        this.modal = false;
        this.$Message.success('已解除');

        setTimeout(() => {
          this.modalRemoveShow = false;
          this.getOrgList();
        }, 300);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
.page-container {
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  .green {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: green;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }
  .purple {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: purple;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }
}
.col-center {
  padding: 0 8px;
  margin-bottom: 8px;
  button + button {
    margin-left: 16px;
  }
}
.tabs-block {
  display: flex;
  margin: 8px 0 24px 0;
  border-bottom: 1px solid #ccc;
  .tab-item {
    padding: 16px 32px;
    border-bottom: 2px solid transparent;
    font-size: 16px;
  }
  .tab-item-active {
    color: #488ffa;
    border-bottom: 2px solid #488ffa;
  }
  .tab-item + .tab-item {
    margin-left: 16px;
  }
}
.op-btn{
  margin-right: 10px;
}
</style>
